import 'magnific-popup/dist/magnific-popup.css';

import './nav-tabs-cmg';
import './home-page';
import './brand-home-page';
import './careers';
import './find-loan/search-loan';
import './loan';
import './loan-tabs';
import './search-blog';
import './grant';
import './calculator/calculator-init';
import './correspondentcontact';
import './ourstory';
import './lo-bar';
import './corporateapplynow';
import './team';
import './partners';
import './true-partners';
import './common';
import './testimonial-video';
import './inputmask';
import './my-site-tab';
import './video-landing-page';
import './embedcode';
import './jvrecruiting-homepage';
import './recruiting-navigation';
import './rate-rebound';
//---------- List-N-Lock ----------------------------------
import './list-n-lock/list-n-lock';
import './list-n-lock/confirmation-page';
import './list-n-lock/floatdown-page';
import './list-n-lock/landing-page';
import './list-n-lock/purchase-page';
import './list-n-lock/rate-search-result-page';
import './list-n-lock/payment-page';
import './list-n-lock/test-page';
//---------------------------------------------------------
import './recruiting-vip-video';
import './communityone';
import './spec-lock/spec-lock';
import './spec-lock/speclock-purchase';
import './spec-lock/speclock-confirmation';
import './builder-forward/confirmation-page';
import './builder-carousel';
import './partner-appraiser';

import $ from 'jquery';
import PageManager from './pageManager';

import SiteNavigator from './siteNavigator';

$(function () {
    new SiteNavigator();
    new PageManager();
});
